import types from "../types/types";

export const getAllRights = (rights) => {
  return (dispatch) => {
    dispatch({
      type: types.SET_USER_RIGHTS,
      payload: rights,
    });
  };
};
